import { CompanySettingsEndpoint as CompanySettingsEndpointInterface } from '@apiClient/interfaces/endpoints/CompanySettings.endpoint';
import { buildSearchParams } from '@/utils/handlers/urlHandler';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import ApiResponseDto from '@/projectRoot/api-client/interfaces/response/ApiResponse.dto';
import SettingDto from '@/projectRoot/api-client/interfaces/models/company/settings/Setting.dto';
import SettingsByTemplateDto from '@/projectRoot/api-client/interfaces/request/company/SettingsByTemplate.dto';

export class CompanySettingsEndpoint implements CompanySettingsEndpointInterface {
   
    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = process.env.NEXT_PUBLIC_ENVIRONMENT == 'staging' ? "no-store" : "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * Return found menu items, always ordered by parent_breadcrumbs and order field
    * /api/company/settings/by-template
    */
    async singleByTemplate(params: SettingsByTemplateDto): Promise<ApiResponseDto<SettingDto, undefined>> {
        return this._httpClient
            .get(`company/settings/by-template`,{ searchParams: buildSearchParams({ template: params.template}), cache: this.cache})
            .then((response: KyResponse) => {
                if (response.status < 200 || response.status > 299) {
                    throw new Error(response.statusText)
                }
                return response.json();
            });
    }
}

export default CompanySettingsEndpoint;